import { extendTheme, theme as ChakraTheme } from "@chakra-ui/react";
import { theme as ProTheme } from "@chakra-ui/pro-theme";
import components from "./components";

export const theme: Record<string, any> = extendTheme({
  components: {
    ...ProTheme["components"],
    Checkbox: ChakraTheme.components.Checkbox,
    ...components,
  },
});
